import { Network } from 'relay-runtime';
import RelayQueryResponseCache from 'relay-runtime/lib/RelayQueryResponseCache';
import * as fetcher from '@hydra/utils/fetcher';

const CACHING_TIME = 15 * 60 * 1000; // caching time in milliseconds
const cache = new RelayQueryResponseCache({ size: 250, ttl: CACHING_TIME });

export const getFetchUrl = pathname => {
  const hostMatch = (pathname || '').match(/^\/[a-z]{2}\/[^/]+\/([^/]+)\/?/);
  if (!hostMatch || !hostMatch[1]) {
    throw new Error('Invalid url!');
  }

  return `/api/crawler/${hostMatch[1]}`;
};

export const fetchQuery = pathname => async (operation, variables, cacheConfig, uploadables) => {
  const url = getFetchUrl(pathname);

  const queryID = operation.text;
  const isMutation = operation.operationKind === 'mutation';
  const isQuery = operation.operationKind === 'query';
  const forceFetch = cacheConfig && cacheConfig.force;

  // Try to get data from cache on queries
  const fromCache = cache.get(queryID, variables);

  if (isQuery && fromCache !== null && !forceFetch) {
    return fromCache;
  }

  const json = await fetcher.post(url, {
    headers: {
      'X-Frame-Options': 'SAMEORIGIN'
    },
    json: {
      query: operation.text,
      variables
    }
  }).json();

  if (isQuery && json) {
    cache.set(queryID, variables, json);
  }

  // Clear all the cache on mutations
  if (isMutation) {
    cache.clear();
  }

  return json;
};

export default pathname => Network.create(fetchQuery(pathname));
